// client/currentUser.ts
import { OptimisticObservable } from "@adornis/base/rxjs-extension/index.js";
import "@adornis/base/utilTypes.js";
import { baseqlMetaData } from "@adornis/baseql/metadata/metaDataStore.js";
import { subscribeByID } from "@adornis/baseql/operations/mongo.js";
import "@adornis/baseql/utils/queryGeneration.js";
import { BehaviorSubject, combineLatest, map } from "rxjs";
import { AdornisUser } from "../db/a-user.js";
import { CurrentUserInfo } from "../db/currentUserInfo.js";
var userSubscription;
var optimisticUser = new BehaviorSubject(null);
var optimisticUserState = new BehaviorSubject(false);
var _currentUser = new OptimisticObservable(
  combineLatest([optimisticUser, optimisticUserState]).pipe(
    map(([user, state]) => ({ data: user, fullyLoaded: state }))
  ),
  { data: void 0, fullyLoaded: false }
);
var currentUser = () => _currentUser;
var _impersonatingUser = new BehaviorSubject(null);
var impersonatingUser = () => _impersonatingUser;
var isImpersonating = new BehaviorSubject(false);
var updateCurrentUser = (user, state) => {
  optimisticUser.next(user);
  optimisticUserState.next(state);
};
var subscribeCurrentUser = async (userSelectionSet = (user) => user.allFields) => {
  return _subscribeCurrentUser({ userSelectionSet });
};
var unsubscribeCurrentUser = () => userSubscription?.unsubscribe();
var lastUserSelectionSet = (user) => user.allFields;
var _subscribeCurrentUser = async ({
  userID,
  userClass,
  userSelectionSet
} = {}) => {
  userSubscription?.unsubscribe();
  if (userSelectionSet) {
    lastUserSelectionSet = userSelectionSet;
  } else {
    userSelectionSet = lastUserSelectionSet;
  }
  let impersonatingUserID = null;
  if (!userID) {
    ({ userID, userClass, impersonatingUserID } = await CurrentUserInfo.getCurrentUserInfo()(
      CurrentUserInfo.allFields
    ));
  }
  if (!userID || !userClass) {
    _impersonatingUser.next(null);
    updateCurrentUser(null, true);
    return;
  }
  const userNode = baseqlMetaData.entities.resolveNode(userClass);
  const userEntity = userNode.type();
  userSubscription = subscribeByID(
    AdornisUser,
    impersonatingUserID ? [userID, impersonatingUserID] : [userID]
  )(userSelectionSet(userEntity)).subscribe({
    next: (users) => {
      const user = users.find((u) => u._id === userID);
      const impersonating = users.find((u) => u._id === impersonatingUserID);
      _impersonatingUser.next(impersonating ?? null);
      isImpersonating.next(!!impersonatingUserID);
      updateCurrentUser(user ?? null, true);
    },
    complete: () => {
      updateCurrentUser(null, true);
    }
  });
};
export {
  _subscribeCurrentUser,
  currentUser,
  impersonatingUser,
  isImpersonating,
  subscribeCurrentUser,
  unsubscribeCurrentUser,
  updateCurrentUser
};
